module.exports = __webpack_public_path__ + "img/tools_super_compensation2.de2d9513.jpg";